export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-bold-web-5ff5537d3939b1dcbb3b7b5fcc72af18.eot";